import api from "../api";

export const ACTION_TYPES = {
    FETCH_USER_PROFILE: 'FETCH_USER_PROFILE',
    CLEAN_USER_PROFILE: 'CLEAN_USER_PROFILE'
}

export const fetch_User_Profile = (lang, token, onError, onSuccess) => dispatch => {
    api.UserProfile().fetchUserProfile(lang, token)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_USER_PROFILE,
                payload: response
            })
            onSuccess()
        })
        .catch(err => onError(err))
}